export default __webpack_public_path__ + "static/media/cert3.2a5fac0e.jpg";